import Clipboard from './Clipboard';

export default {
  clipboard: [ 'type', Clipboard ]
};
